import { useRouterState } from "@tanstack/react-router";

export type Locale = "en" | "es";

/** Returns the active locale based on the current URL path prefix. */
export function useLocale(): Locale {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return pathname === "/es" || pathname.startsWith("/es/") ? "es" : "en";
}

/** Map an English public path to its Spanish twin (and vice versa). */
const EN_TO_ES: Record<string, string> = {
  "/": "/es",
  "/medical-reset": "/es/medical-reset",
  "/store": "/es/tienda",
  "/news": "/es/noticias",
  "/menopause-guide": "/es/guia-menopausia",
  "/guide/fsh-levels": "/es/guia/niveles-fsh",
  "/guide/heart-palpitations": "/es/guia/palpitaciones",
  "/guide/menopause-age-calculator": "/es/guia/calculadora-edad",
  "/guide/perimenopause-test": "/es/guia/test-perimenopausia",
  "/privacy": "/es/privacidad",
  "/terms": "/es/terminos",
  "/cookies": "/es/cookies",
  "/disclaimer": "/es/aviso-legal",
  "/consumer-health-privacy": "/es/privacidad-salud",
};
const ES_TO_EN: Record<string, string> = Object.fromEntries(
  Object.entries(EN_TO_ES).map(([k, v]) => [v, k]),
);

export function toLocalePath(pathname: string, target: Locale): string {
  const current: Locale =
    pathname === "/es" || pathname.startsWith("/es/") ? "es" : "en";
  if (current === target) return pathname;
  if (target === "es") return EN_TO_ES[pathname] ?? "/es";
  return ES_TO_EN[pathname] ?? "/";
}

export const LOCALE_STORAGE_KEY = "knowmeno_locale";
